import { getFormattedDate } from '../getFormattedDate';

export function getArticlePublicationDate(
  datePublished: string | undefined,
  enabled: boolean,
  locale: string,
): string | undefined {
  if (!enabled || !datePublished) {
    return undefined;
  }

  return getFormattedDate(datePublished, 'dd MMM yyyy', locale);
}
